import React from 'react';
import { aludeCNPJ } from '../../../constants/support';
import { classes } from '../../../lib';
import { Logotype } from '../../Logotype';
import { LpLink } from '../LpLink';
import Styles from './Footer.module.less';

type MenuItem = {
    title: string;
    link?: string;
    children: MenuItem[];
};

type SocialMedia = {
    icon: React.ReactNode;
    name: string;
    link: string;
};

export type FooterProps = {
    year: string;
    links: MenuItem[];
    socialMediaLinks: SocialMedia[];
    hideMenu?: boolean;
};

const FooterSubGroup = ({ title, children }: MenuItem) => {
    return (
        <div className="vertical stretch-top g16">
            <span className="semilarge-alude semibold alude-gray-0">
                {title}
            </span>
            {children.map(child => (
                <LpLink
                    key={child.title}
                    className={classes(Styles.linkChild, 'medium-alude')}
                    to={child.link}>
                    {child.title}
                </LpLink>
            ))}
        </div>
    );
};

const Copyright = ({ year }: { year: string }) => {
    return (
        <div className="d-horizontal d-left-middle mt-vertical mt-center-middle flex-1 g8">
            <Logotype type="DefaultIcon" className={Styles.logo} />
            <span
                className={classes(
                    Styles.company,
                    'alude-white-opac-70 medium-alude'
                )}>
                Alude {year} - CNPJ: {aludeCNPJ} - Todos os direitos reservados
            </span>
        </div>
    );
};

const SocialMediaLink = (link: SocialMedia) => (
    <div className={Styles.socialMedia}>
        <a
            target="_blank"
            rel="noopener noreferrer"
            className={classes(Styles.socialMediaLink, 'alude-gray-0')}
            title={link.name}
            href={link.link}>
            {link.icon}
        </a>
    </div>
);

export const Footer = (p: FooterProps): JSX.Element => {
    return (
        <div
            className={classes(
                'vertical center-middle bg-alude-storm-8',
                Styles.container
            )}>
            <div
                className={classes(
                    Styles.footer,
                    'vertical stretch-top px32 py56'
                )}>
                {!p.hideMenu && (
                    <>
                        <div className={classes('pb56', Styles.links)}>
                            {p.links.map(item => (
                                <FooterSubGroup key={item.title} {...item} />
                            ))}
                        </div>
                        <hr className={classes(Styles.hr)} />
                    </>
                )}
                <div className="horizontal center-middle g24 pt24 reverse-wrap">
                    <Copyright year={p.year} />
                    <div className="horizontal left-middle g16">
                        {p.socialMediaLinks.map(link => (
                            <SocialMediaLink key={link.link} {...link} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
